import FilterTag from "components/FilterTag";
import { CustomerAccount } from "models/accountSummary";
import { ApplicationUser } from "models/applicationUsers";
import { ClearTableFilterRequest } from "models/common";
import { customerAccountDisplay } from "util/helpers";

export interface StaffTransactionFilterDetail {
    description?: string | undefined;
    type?: string | undefined;
    customer?: ApplicationUser | undefined;
    account?: CustomerAccount | undefined;
}

const StaffTransactionFilter = (props: {
    detail: StaffTransactionFilterDetail;
}) => {
    const { description, type, account } = props.detail;

    return (
        <div id="staff-card-active-filters">
            {description && (
                <FilterTag
                    filter={ClearTableFilterRequest.Name}
                    text={`Desc. contains '${description}'`}
                />
            )}
            {type && (
                <FilterTag
                    filter={ClearTableFilterRequest.Type}
                    text={`Type: ${type}`}
                />
            )}
            {account && (
                <FilterTag
                    filter={ClearTableFilterRequest.Customer}
                    text={`Customer: ${customerAccountDisplay(account)}`}
                />
            )}
        </div>
    );
};

export default StaffTransactionFilter;
